import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { TranscriptMesssage } from '@/app/models/translator/transcript.ts';

export enum TranslationState {
  Listening = 'listening',
  Translating = 'translating',
  Speaking = 'speaking',
  Idle = 'idle'
}

export type TranslatorState = {
  currentState: 'setup' | 'active' | 'finished';
  conversationId: string;
};

const initialState: TranslatorState = {
  currentState: 'setup',
  conversationId: ''
};

export const translatorSlice = createSlice({
  name: 'TRANSLATOR',
  initialState,
  reducers: {
    setupConversation(state) {
      state.currentState = 'setup';
    },
    startConversation(state) {
      state.currentState = 'active';
      state.conversationId = crypto.randomUUID();
    },
    endConversation(state) {
      state.currentState = 'finished';
      state.conversationId = '';
    }
  }
});
